import { FunctionComponent, memo } from 'react';
import sprite from '../../../assets/icons/sprite.svg';

import classNames from 'classnames';
import classes from './Check.module.scss';

export enum CheckLabelSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export interface CheckProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  labelSize?: CheckLabelSizes;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  className?: string;
}

export const Check: FunctionComponent<CheckProps> = memo(
  ({
    checked,
    onChange,
    disabled,
    label,
    labelSize = CheckLabelSizes.medium,
    ariaLabel,
    ariaLabelledBy,
    className,
  }) => {
    return (
      <label
        className={classNames(
          classes['check'],
          classes[`check--${labelSize}`],
          { [classes['check--checked']]: checked },
          { [classes['check--has-label']]: label },
          { [classes['check--disabled']]: disabled },
          className
        )}
      >
        {checked && (
          <svg className={classes['check__icon']}>
            <use href={`${sprite}#checkmark`} />
          </svg>
        )}

        <input
          type={'checkbox'}
          className={classes['check__input']}
          checked={checked}
          disabled={disabled}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy}
          onChange={({ target }) => onChange(target.checked)}
        />

        {label && <span className={classes['check__label']}>{label}</span>}
      </label>
    );
  }
);

interface CheckIndicatorProps {
  checked: boolean;
  label: string;
  labelSize: CheckLabelSizes;
}

export const CheckIndicator: FunctionComponent<CheckIndicatorProps> = memo(
  ({ checked, label, labelSize }) => {
    return (
      <span
        className={classNames(
          classes['check'],
          classes[`check--${labelSize}`],
          classes['check--has-label'],
          { [classes['check--checked']]: checked }
        )}
      >
        {checked && (
          <svg className={classes['check__icon']}>
            <use href={`${sprite}#checkmark`} />
          </svg>
        )}

        <span className={classes['check__label']}>{label}</span>
      </span>
    );
  }
);
